export const staticLabelsCompare = {
  en: {
    compareProducts: "Compare Products",
    back: "Back",
    clearResults: "Clear Results",
    compare: "Compare",
  },
  id: {
    compareProducts: "Perbandingan Produk",
    back: "Kembali",
    clearResults: "Hasil yang jelas",
    compare: "Membandingkan",
  },
}
